import { post } from './ApiService';
import { ServerEndpoint } from '../Redux/endpoints.ts';

const NewsletterService = {
    async subscribe(email) {
        const res = await post(ServerEndpoint.NEWSLETTER, { email });
        if (res?.data?.error) throw new Error(res.data.error);
        return res?.data?.data;
    },
};

export default NewsletterService;
